"use client";

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import FacilityRequestModal from '@/components/common/FacilityRequestModal';

export default function ForFacilitiesClient() {
  const [facilityModalOpen, setFacilityModalOpen] = useState(false);

  return (
    <>
      <section className="py-24 bg-gradient-to-br from-[#f8faf9] via-white to-[#f0f4f2]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#26342f] mb-6">Ready to hire?</h2>
          <p className="text-lg sm:text-xl md:text-2xl text-[#3a4d46] mb-10">Tell us what you need. We'll send candidates in 48 hours.</p>
          <button
            onClick={() => setFacilityModalOpen(true)}
            className="group inline-flex items-center px-10 py-5 text-lg font-semibold text-white bg-gradient-to-r from-[#26342f] to-[#3a4d46] rounded-2xl transition-all duration-300 hover:shadow-[0_0_40px_rgba(93,211,158,0.4)] hover:-translate-y-1"
          >
            Request candidates now
            <Icon name="ArrowRightIcon" size={20} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </div>
      </section>

      <FacilityRequestModal isOpen={facilityModalOpen} onClose={() => setFacilityModalOpen(false)} />
    </>
  );
}